import Nav from "react-bootstrap/Nav";

import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import dashboaradim from "../Assets/images/dashboard.svg";
import goalsim from "../Assets/images/goals.svg";
import skillsim from "../Assets/images/skills.svg";
import appraisalim from "../Assets/images/appraisal.svg";
import carbonplan from "../Assets/images/carbonplan.svg";
import performance from "../Assets/images/mdi_performance.svg";
import compmapping from "../Assets/images/iconmapping.svg";
import { useLocation } from "react-router-dom";
import { baseURL } from "../config";
import Teamimg1 from "../images/Frame 386.png";

const Sidemenu = () => {
  const location = useLocation();
  let profileimage = localStorage.getItem("profileimage");

  let path = location.pathname;

  let user = localStorage.getItem("username");

  let role = localStorage.getItem("userrole");
  let appealcommitte = localStorage.getItem("appealcommiteememberstatus");
  let searchString = "ROLE_";
  let showAppealList = false;
  let rolename = "";
  if (
    profileimage === "" ||
    profileimage === undefined ||
    profileimage === "null"
  ) {
    profileimage = "dummyphoto.png";
  }

  if (role) {
    rolename = role.substring(role.indexOf(searchString) + searchString.length);
  } else {
    rolename = "guest";
  }
  if (appealcommitte === "Yes") {
    showAppealList = true;
  } else {
    showAppealList = false;
  }

  if (role === "ROLE_HR" || role === "ROLE_SENIOR HR MANAGER")
    return (
      <div className="sidebar">
        <div className="pt-3">
          <div className="row">
            <div className="col-lg-3 pt-2">
              <img
  width="32"
  alt="om"
  src={`${baseURL}/getcertifcate?filename=${profileimage}`}
  onError={(e) => {
    e.target.onerror = null; // prevents infinite loop if fallback also fails
    e.target.src = Teamimg1;
  }}
/>
            </div>
            <div className="col-lg-8">
              <h5>{user}</h5>
              <p>{rolename}</p>
            </div>
          </div>
        </div>
        <Nav className="flex-column pt-3">
          <div className="d-flex active">
            <img src={dashboaradim} width="20" />
            <Nav.Link className="" href="/dashboard">
              Dashboard
            </Nav.Link>
          </div>

          <div className="d-flex active">
            <img src={goalsim} width="20" />
            <Nav.Link href="/goals">KPI</Nav.Link>
          </div>

          <div className="d-flex">
            <img src={skillsim} width="20" />
            <NavDropdown
              title="Skills"
              href="/skills"
              id="basic-nav-dropdown"
              className="border-0"
            >
              <NavDropdown.Item className="/skills" href="/myskills">
                My Skill
              </NavDropdown.Item>
              <NavDropdown.Item className="/skills" href="/skills">
                Department Skills
              </NavDropdown.Item>
              {/* <NavDropdown.Item href="/#">
      My Team Skill
       </NavDropdown.Item> */}

              {/* <NavDropdown.Divider /> */}
              {/* <NavDropdown.Item href="#action/3.4">
         Separated link
       </NavDropdown.Item> */}
            </NavDropdown>
          </div>

          <div className="d-flex">
            <img src={appraisalim} width="20" />
            <NavDropdown title="Appraisal" id="basic-nav-dropdown">
              <NavDropdown.Item href="/myappraisal">
                My Appraisal
              </NavDropdown.Item>
              <NavDropdown.Item href="Initiateappraisal">
                Initiate Appraisal
              </NavDropdown.Item>
              <NavDropdown.Item href="/myteamappraisal">
                My Team Appraisal
              </NavDropdown.Item>
              <NavDropdown.Item href="/createtemplate">
                Create Template
              </NavDropdown.Item>
              <NavDropdown.Item href="/subcategorytable">
                Sub Categories
              </NavDropdown.Item>
              {showAppealList && (
                <NavDropdown.Item href="/appealapprovaltable">
                  Appeal Appraisal
                </NavDropdown.Item>
              )}
              <NavDropdown.Item href="/listappraisal">
                List Appraisals
              </NavDropdown.Item>
              <NavDropdown.Item href="/listpastappraisal">
                List Past Appraisals
              </NavDropdown.Item>

              {/* <NavDropdown.Divider /> */}
              {/* <NavDropdown.Item href="#action/3.4">
         Separated link
       </NavDropdown.Item> */}
            </NavDropdown>
          </div>

          <div className="d-flex">
            <img src={carbonplan} width="20" />
            <NavDropdown title="Training Needs" id="basic-nav-dropdown">
              <NavDropdown.Item href="/myplan">My Plan</NavDropdown.Item>
              <NavDropdown.Item href="/myteamplanidp">
                My Team Plan
              </NavDropdown.Item>
              <NavDropdown.Item href="/createtrainingform">
                Create Training{" "}
              </NavDropdown.Item>
              <NavDropdown.Item href="/assigntostaff">
                AssignTraining
              </NavDropdown.Item>
              <NavDropdown.Item href="/listelement">
                ListTraining
              </NavDropdown.Item>
              {/* <NavDropdown.Divider /> */}
              {/* <NavDropdown.Item href="#action/3.4">
         Separated link
       </NavDropdown.Item> */}
            </NavDropdown>
          </div>

          <div className="d-flex">
            <img src={compmapping} width="20" />

            <NavDropdown title="Competency" id="basic-nav-dropdown">
              <NavDropdown.Item href="/ListClusterandComp">
                List Cluster & Comp
              </NavDropdown.Item>
              <NavDropdown.Item href="/ListJobFamRole">
                List JobFam & Role
              </NavDropdown.Item>
              {/* <NavDropdown.Item href="/myteamcomp">My Team Competency</NavDropdown.Item> */}
              <NavDropdown title="Master" id="basic-nav-dropdown">
                <NavDropdown.Item href="/mastercluster">
                  Master Cluster
                </NavDropdown.Item>
                <NavDropdown.Item href="/mastercompetency">
                  Master Competency
                </NavDropdown.Item>
                <NavDropdown.Item href="/masterjobfamily">
                  Master JobFamily
                </NavDropdown.Item>
                <NavDropdown.Item href="/masterjobrole">
                  Master JobRole
                </NavDropdown.Item>

                {/* <NavDropdown.Divider /> */}
                {/* <NavDropdown.Item href="#action/3.4">
Separated link
</NavDropdown.Item> */}
              </NavDropdown>

              {/* <NavDropdown.Divider /> */}
              {/* <NavDropdown.Item href="#action/3.4">
         Separated link
       </NavDropdown.Item> */}
            </NavDropdown>
          </div>

          <div className="d-flex">
            <img src={performance} width="20" />
            <NavDropdown title="PIP" id="basic-nav-dropdown">
              <NavDropdown.Item href="/initiatepipdirect">
                Initiate PIP
              </NavDropdown.Item>
              <NavDropdown.Item href="/piptable">PIP Requests</NavDropdown.Item>

              {/* <NavDropdown.Divider /> */}
              {/* <NavDropdown.Item href="#action/3.4">
         Separated link
       </NavDropdown.Item> */}
            </NavDropdown>
          </div>

          <div className="d-flex">
            <img src={skillsim} width="20" />
            <NavDropdown title="Awards" id="basic-nav-dropdown">
              <NavDropdown.Item href="/eomlist">EOM List</NavDropdown.Item>
              <NavDropdown.Item href="/startofyearlist">
                Star of the Year List
              </NavDropdown.Item>
              <NavDropdown.Item href="/teamofquarterlist">
                Team Quarter List
              </NavDropdown.Item>
              <NavDropdown.Item href="/leaderofquarterlist">
                Leader of Quarter List
              </NavDropdown.Item>
              <NavDropdown.Item href="/employeeofdeptlist">
                Employee of Department
              </NavDropdown.Item>

              {/* <NavDropdown.Divider /> */}
              {/* <NavDropdown.Item href="#action/3.4">
           Separated link
         </NavDropdown.Item> */}
            </NavDropdown>
          </div>
          <div className="d-flex">
            <img src={skillsim} width="20" />
            <NavDropdown title="User Admin" id="basic-nav-dropdown">
              <NavDropdown.Item href="/userformspage">
                Add User
              </NavDropdown.Item>

              <NavDropdown.Item href="/userTable">User List</NavDropdown.Item>

              {/* <NavDropdown.Divider /> */}
              {/* <NavDropdown.Item href="#action/3.4">
           Separated link
         </NavDropdown.Item> */}
            </NavDropdown>
          </div>

          <div className="d-flex">
            <img src={skillsim} width="20" />
            <NavDropdown title="Reports" id="basic-nav-dropdown">
              <NavDropdown.Item href="/reports">
                Master Employee Score
              </NavDropdown.Item>
              <NavDropdown.Item href="/reappraisal">
                Re-Appraisal Report
              </NavDropdown.Item>
              <NavDropdown.Item href="/kpireports">KPI Report</NavDropdown.Item>

              <NavDropdown.Item href="/kpioverall">
                Overall KPI Report
              </NavDropdown.Item>
              <NavDropdown.Item href="/awardsreport">
                Awards Report
              </NavDropdown.Item>
              <NavDropdown.Item href="/pipdev">
                PIP Dev. Report
              </NavDropdown.Item>

              {/* <NavDropdown.Divider /> */}
              {/* <NavDropdown.Item href="#action/3.4">
           Separated link
         </NavDropdown.Item> */}
            </NavDropdown>
          </div>
        </Nav>
      </div>
    );

  if (role === "ROLE_MANAGER" || role === "ROLE_SUPERVISOR")
    return (
      <div className="sidebar">
        <div className="pt-3">
          <div className="row">
            <div className="col-lg-3 pt-2">
              <img
                width="32"
                alt="lll"
                src={
                  `${baseURL}/getcertifcate?filename=` + profileimage
                }
              ></img>
            </div>
            <div className="col-lg-8">
              <h5>{user}</h5>
              <p>{rolename}</p>
            </div>
          </div>
        </div>
        <Nav className="flex-column pt-3">
          <div className="d-flex active">
            <img src={dashboaradim} width="20" />
            <Nav.Link className="" href="/dashboard">
              Dashboard
            </Nav.Link>
          </div>

          <div className="d-flex active">
            <img src={goalsim} width="20" />
            <Nav.Link href="/goals">KPI</Nav.Link>
          </div>

          <div className="d-flex">
            <img src={skillsim} width="20" />
            <NavDropdown
              title="Skills"
              id="basic-nav-dropdown"
              className="border-0"
            >
              <NavDropdown.Item className="" href="/myskills">
                My Skill
              </NavDropdown.Item>
              <NavDropdown.Item className="/skills" href="/skills">
                My Team Skill
              </NavDropdown.Item>
              {/* <NavDropdown.Item href="/#">
         My Team Skill
          </NavDropdown.Item> */}

              {/* <NavDropdown.Divider /> */}
              {/* <NavDropdown.Item href="#action/3.4">
            Separated link
          </NavDropdown.Item> */}
            </NavDropdown>
          </div>

          <div className="d-flex">
            <img src={appraisalim} width="20" />
            <NavDropdown title="Appraisal" id="basic-nav-dropdown">
              <NavDropdown.Item href="/myappraisal">
                My Appraisal
              </NavDropdown.Item>
              <NavDropdown.Item href="/myteamappraisal">
                My Team Appraisal
              </NavDropdown.Item>
              {/* <NavDropdown.Item href="/createtemplate">Create Template</NavDropdown.Item> */}
              {showAppealList && (
                <NavDropdown.Item href="/appealapprovaltable">
                  Appeal Appraisal
                </NavDropdown.Item>
              )}
              <NavDropdown.Item href="/listappraisal">
                List Appraisal
              </NavDropdown.Item>
              {/* <NavDropdown.Divider /> */}
              {/* <NavDropdown.Item href="#action/3.4">
            Separated link
          </NavDropdown.Item> */}
            </NavDropdown>
          </div>

          <div className="d-flex">
            <img src={carbonplan} width="20" />
            <NavDropdown title="Training Needs" id="basic-nav-dropdown">
              <NavDropdown.Item href="/myplan">My Plan</NavDropdown.Item>
              <NavDropdown.Item href="/myteamplanidp">
                My Team Plan
              </NavDropdown.Item>
              <NavDropdown.Item href="/createtrainingform">
                Create Training{" "}
              </NavDropdown.Item>
              <NavDropdown.Item href="/assigntostaff">
                AssignTraining
              </NavDropdown.Item>
              <NavDropdown.Item href="/listelement">
                ListTraining
              </NavDropdown.Item>
              {/* <NavDropdown.Divider /> */}
              {/* <NavDropdown.Item href="#action/3.4">
            Separated link
          </NavDropdown.Item> */}
            </NavDropdown>
          </div>

          <div className="d-flex">
            <img src={compmapping} width="20" />

            <NavDropdown title="Competency" id="basic-nav-dropdown">
              <NavDropdown.Item href="/ListClusterandComp">
                List Cluster & Comp
              </NavDropdown.Item>
              <NavDropdown.Item href="/ListJobFamRole">
                List JobFam & Role
              </NavDropdown.Item>
              {/* <NavDropdown.Item href="/myteamcomp">My Team Competency</NavDropdown.Item> */}
              <NavDropdown title="Master" id="basic-nav-dropdown">
                <NavDropdown.Item href="/mastercluster">
                  Master Cluster
                </NavDropdown.Item>
                <NavDropdown.Item href="/mastercompetency">
                  Master Competency
                </NavDropdown.Item>
                <NavDropdown.Item href="/masterjobfamily">
                  Master JobFamily
                </NavDropdown.Item>
                <NavDropdown.Item href="/masterjobrole">
                  Master JobRole
                </NavDropdown.Item>

                {/* <NavDropdown.Divider /> */}
                {/* <NavDropdown.Item href="#action/3.4">
  Separated link
</NavDropdown.Item> */}
              </NavDropdown>

              {/* <NavDropdown.Divider /> */}
              {/* <NavDropdown.Item href="#action/3.4">
            Separated link
          </NavDropdown.Item> */}
            </NavDropdown>
          </div>

          <div className="d-flex">
            <img src={performance} width="20" />
            <NavDropdown title="PIP" id="basic-nav-dropdown">
              <NavDropdown.Item href="/initiatepipdirect">
                Initiate PIP
              </NavDropdown.Item>

              <NavDropdown.Item href="/piptable">PIP List</NavDropdown.Item>
              <NavDropdown.Item href="/piptable?mypip=1">
                My PIP
              </NavDropdown.Item>

              {/* <NavDropdown.Divider /> */}
              {/* <NavDropdown.Item href="#action/3.4">
            Separated link
          </NavDropdown.Item> */}
            </NavDropdown>
          </div>

          <div className="d-flex">
            <img src={skillsim} width="20" />
            <NavDropdown title="Awards" id="basic-nav-dropdown">
              <NavDropdown.Item href="/awardsform">
                Employee of Month
              </NavDropdown.Item>
              <NavDropdown.Item href="/startofyear">
                Star Of The Year
              </NavDropdown.Item>
              <NavDropdown.Item href="/teamofquarter">
                Team Of Quarter
              </NavDropdown.Item>
              <NavDropdown.Item href="/leaderofquarter">
                Leader Of Quarter
              </NavDropdown.Item>
              <NavDropdown.Item href="/employeeofdept">
                Employee Of Dept.
              </NavDropdown.Item>

              {/* <NavDropdown.Divider /> */}
              {/* <NavDropdown.Item href="#action/3.4">
           Separated link
         </NavDropdown.Item> */}
            </NavDropdown>
          </div>
        </Nav>
      </div>
    );
  else if (role == "ROLE_USER") {
    return (
      <div className="sidebar">
        <div className="pt-3">
          <div className="row">
            <div className="col-lg-3 pt-2">
              <img
                width="32"
                alt="jjj"
                src={
                  `${baseURL}/getcertifcate?filename=` + profileimage
                }
              ></img>
            </div>
            <div className="col-lg-8">
              <h5>{user}</h5>
              <p>{rolename}</p>
            </div>
          </div>
        </div>
        <Nav className="flex-column pt-3">
          <div className="d-flex active">
            <img src={dashboaradim} width="20" />
            <Nav.Link className="" href="/dashboard">
              Dashboard
            </Nav.Link>
          </div>

          <div className="d-flex">
            <img src={goalsim} width="20" />
            <Nav.Link href="/goals">KPI</Nav.Link>
          </div>
          <div className="d-flex">
            <img src={skillsim} width="20" />
            <NavDropdown
              title="Skills"
              id="basic-nav-dropdown"
              className="border-0"
            >
              <NavDropdown.Item className="/skills" href="/skills">
                My Skill
              </NavDropdown.Item>
              {/* <NavDropdown.Item href="/#">
         My Team Skill
          </NavDropdown.Item> */}

              {/* <NavDropdown.Divider /> */}
              {/* <NavDropdown.Item href="#action/3.4">
            Separated link
          </NavDropdown.Item> */}
            </NavDropdown>
          </div>

          <div className="d-flex">
            <img src={appraisalim} width="20" />
            <NavDropdown title="Appraisal" id="basic-nav-dropdown">
              <NavDropdown.Item href="/myappraisal">
                My Appraisal
              </NavDropdown.Item>
            </NavDropdown>
          </div>
          <div className="d-flex">
            <img src={performance} width="20" />
            <NavDropdown title="PIP" id="basic-nav-dropdown">
              <NavDropdown.Item href="/piptable">My PIP</NavDropdown.Item>

              {/* <NavDropdown.Divider /> */}
              {/* <NavDropdown.Item href="#action/3.4">
                    Separated link
                  </NavDropdown.Item> */}
            </NavDropdown>
          </div>

          <div className="d-flex">
            <img src={carbonplan} width="20" />
            <NavDropdown title="Logout" id="basic-nav-dropdown">
              <NavDropdown.Item href="/"> Logout </NavDropdown.Item>

              {/* <NavDropdown.Item href="#action/3.4">
     Separated link
   </NavDropdown.Item> */}
            </NavDropdown>
          </div>
        </Nav>
      </div>
    );
  } else if (role == "ROLE_SUPER ADMIN") {
    return (
      <div className="sidebar">
        <div className="pt-3">
          <div className="row">
            <div className="col-lg-3 pt-2">
              <img src={require("../Assets/currentUser.png")}></img>
            </div>
            <div className="col-lg-8">
              <h6 style={{ color: "#DF2331", fontSize: "16px" }}>{user}</h6>
              <p>{rolename}</p>
            </div>
          </div>
        </div>
        <Nav className="flex-column pt-3">
          <div className="d-flex">
            <img src={skillsim} width="20" />
            <NavDropdown title="User Admin" id="basic-nav-dropdown" show={true}>
              <NavDropdown.Item
                href="/userformspage"
                active={path === "/userformspage"}
              >
                Add User
              </NavDropdown.Item>

              <NavDropdown.Item
                href="/userTable"
                active={path === "/userTable"}
              >
                User List
              </NavDropdown.Item>

              <NavDropdown.Item
                href="/passwordchangeadmin"
                active={path === "/passwordchangeadmin"}
              >
                Password Change
              </NavDropdown.Item>

              {/* <NavDropdown.Divider /> */}
              {/* <NavDropdown.Item href="#action/3.4">
           Separated link
         </NavDropdown.Item> */}
            </NavDropdown>
          </div>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <div className="d-flex">
            <img src={goalsim} width="20" alt="Goal Icon" />

            <NavDropdown title="Master" id="basic-nav-dropdown" show={true}>
              <NavDropdown.Item
                href="/adddesignation"
                active={path === "/adddesignation"}
              >
                Add Designation
              </NavDropdown.Item>
              <NavDropdown.Item
                href="/adddepartment"
                active={path === "/adddepartment"}
              >
                Add Department
              </NavDropdown.Item>
            </NavDropdown>
          </div>

          <br></br>
          <br></br>
          <br></br>
          <br></br>

          <div className="d-flex">
            <img src={goalsim} width="20" alt="Goal Icon" />

            <NavDropdown
              title="Announcement"
              id="basic-nav-dropdown"
              show={true}
            >
              <NavDropdown.Item
                href="/Announcement"
                active={path === "/Announcement"}
              >
                Announcement Form
              </NavDropdown.Item>

              <NavDropdown.Item
                href="/AnnouncementList"
                active={path === "/AnnouncementList"}
              >
                Announcement List
              </NavDropdown.Item>
            </NavDropdown>
          </div>
        </Nav>
      </div>
    );
  }
};

export default Sidemenu;
